<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Hero Section -->
        <div class="relative h-64 md:h-80 w-full flex items-center justify-center overflow-hidden">
            <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=900&q=80"
                alt="Cancellation Hero" class="absolute inset-0 w-full h-full object-cover object-center opacity-80" />
            <div class="relative z-10 flex flex-col items-center justify-center w-full h-full">
                <span class="uppercase tracking-widest text-white text-xs md:text-sm mb-2">Our Policy</span>
                <h1 class="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg mb-2 text-center">Cancellation
                    Policy</h1>
                <p class="text-white text-base md:text-lg font-medium drop-shadow text-center">How to manage or cancel
                    your subscription</p>
            </div>
            <div class="absolute inset-0 bg-gradient-to-b from-blue-900/60 to-transparent"></div>
        </div>

        <!-- Main Content -->
        <div class="max-w-3xl mx-auto -mt-16 pb-16 px-4">
            <div class="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative z-20">
                <section class="mb-8">
                    <h2 class="text-xl font-semibold text-gray-900 mb-4">You may cancel your OptimaAI subscription at
                        any time. Cancellations will take effect at the end of your current billing period.</h2>
                </section>
                <div class="divide-y divide-blue-50">
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">1.</span>
                            Subscription Cancellation</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Cancellations must be made at least 24 hours before your next billing date</li>
                            <li>No refunds will be provided for partial subscription periods</li>
                            <li>You will continue to have access to all features until the end of your billing period
                            </li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">2.</span>
                            How to Cancel</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Log in to your OptimaAI account</li>
                            <li>Navigate to Account Settings</li>
                            <li>Select "Subscription"</li>
                            <li>Click "Cancel Subscription"</li>
                            <li>Follow the confirmation prompts</li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">3.</span>
                            Post-Cancellation</h3>
                        <ul class="list-disc pl-6 text-gray-700">
                            <li>Your account will remain active until the end of your billing period</li>
                            <li>You can reactivate your subscription at any time</li>
                            <li>Your data will be retained for 30 days after cancellation</li>
                        </ul>
                    </section>
                    <section class="py-6">
                        <h3 class="text-lg font-bold text-gray-900 mb-2 flex items-center"><span class="mr-2">4.</span>
                            Contact Us</h3>
                        <p class="text-gray-700">If you have any questions about our cancellation policy, please contact
                            us at:</p>
                        <p class="text-blue-700 font-semibold">Email: support@optimaai.app</p>
                        <p class="text-blue-700 font-semibold">Phone: +1 (800) 888-8888</p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CancellationPolicy'
}
</script>